import { Checkbox } from '@/components/ui/checkbox';
import { useToast } from '@/components/ui/hooks/use-toast';
import { getCoachesMissingZoomLicense, updateCoachProfile } from '@/lib/api-calls';
import { airServerErrorFrom } from '@/lib/error-handling';
import { FullCoach, ZoomType } from '@airreading/common/data';
import { useQueryClient, useMutation } from '@tanstack/react-query';

export const CheckboxZoomLicense = (props: FullCoach) => {
  const { id, zoomType } = props;
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const { mutateAsync: updateCoachProfileMutate } = useMutation({ mutationFn: updateCoachProfile });

  const onChange = async () => {
    try {
      await updateCoachProfileMutate({
        userId: id,
        data: {
          zoomType: zoomType ? ZoomType.license : ZoomType.basic,
        },
      });

      queryClient.invalidateQueries(getCoachesMissingZoomLicense());
    } catch (e) {
      toast({
        title: airServerErrorFrom(e)?.userFacingMessage || 'Failed to update zoom license',
      });
    }
  };

  return <Checkbox checked={zoomType === 'license'} onCheckedChange={onChange} />;
};
